import { lazy } from 'react';

const LoginPage          = lazy(() => import('./pages/Login'));
const DashboardPage      = lazy(() => import('./pages/Dashboard'));
const AssignmentsPage    = lazy(() => import('./pages/Assignments'));
const AssignmentDetailPage = lazy(() => import('./pages/AssignmentDetail'));

/**
 * Centralt route-register.
 * Alla sidor laddas lazy (code-splitting per rutt).
 */
export const routes = {
  login:            <LoginPage />,
  dashboard:        <DashboardPage />,
  assignments:      <AssignmentsPage />,
  assignmentDetail: <AssignmentDetailPage />,
};
